// lingland-frontend/src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram, Linkedin } from 'lucide-react';
import logoImage from '../../assets/images/logo-lingland.png';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const emailAddress = "lingland.contact@gmail.com";

  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-section footer-logo-section">
          <Link to="/">
            <img src={logoImage} alt="Lingland Logo" className="footer-logo-img" />
          </Link>
          <p className="footer-tagline">{t('footer_tagline')}</p>
        </div>

        <div className="footer-section footer-links">
           <h4>{t('footer_menu')}</h4>
           <ul>
             <li><Link to="/">{t('nav_home')}</Link></li>
             <li><Link to="/uslugi">{t('nav_services')}</Link></li>
             <li><Link to="/cennik">{t('nav_pricing')}</Link></li>
             <li><Link to="/blog">{t('nav_blog')}</Link></li>
             <li><Link to="/kontakt">{t('nav_contact')}</Link></li>
           </ul>
         </div>

        <div className="footer-section footer-legal">
          <h4>{t('footer_info')}</h4>
          <ul>
            <li><Link to="/polityka-prywatnosci">{t('footer_privacy')}</Link></li>
            <li><Link to="/regulamin">{t('footer_terms')}</Link></li>
            <li>
              <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section footer-social">
          <h4>{t('footer_follow')}</h4>
          <div className="social-icons">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Instagram size={24} strokeWidth={1.5}/>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={24} strokeWidth={1.5}/>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{t('footer_copyright', { year: currentYear })}</p>
      </div>
    </footer>
  );
}
export default Footer;